export { default as BodyDefault } from "./BodyDefault"
export { default as BodyDefaultLight } from "./BodyDefaultLight"
export { default as BodySmall } from "./BodySmall"
export { default as BodyTiny } from "./BodyTiny"
export { default as ButtonLabel } from "./ButtonLabel"
export { default as Heading1 } from "./Heading1"
export { default as Heading2 } from "./Heading2"
export { default as Heading3 } from "./Heading3"
export { default as Heading4 } from "./Heading4"
export { default as Heading5 } from "./Heading5"
export { default as Heading6 } from "./Heading6"
export { default as Label } from "./Label"
export { OrderedList, UnorderedList } from "./Lists"
export { default as Tag } from "./Tag"
